export default "__VITE_ASSET__8763ae6b__"